<template>
  <div class="w-100 cursor-pointer">
    <div class="form-container-input">
      <div class="label-icon">
        <i :class="icon"></i>
        <label>
          {{ label }}
        </label>
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "label-title",

  props: {
    label: {
      type: String,
      required: true
    },
    icon: {
      String,
      required: true
    }
  }
}
</script>

<style scoped>

</style>